import { useSelector } from "react-redux"
import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import RoomCardBody from "../../shared/RoomCardBody/RoomCardBody"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import Wrapper from "../../shared/Wrapper/Wrapper"
import { useVentaEnLineaCountdown } from "../../../../hooks/useVentaEnLineaCountdown"
import { useMaxWidthContext } from "../../../hooks/useMaxWidth"
import { RootState } from "src/store/store"

import "./VentaEnLinea.css"

const VentaEnLinea = ({
    roomNumber,
    roomTypeName,
    occupiedTimeStart,
    hasIncidences,
    ventaEnLineaCodigo,
    occupiedTimeEndCondensada,
}: RoomStatusProps) => {
    const { timeLeft, isExceeded } = useVentaEnLineaCountdown(occupiedTimeStart, occupiedTimeEndCondensada)
    const { maxWidth } = useMaxWidthContext()

    const { roomsDimensions } = useSelector((state: RootState) => state.rooms)

    const itemHeight = `calc(calc(80dvh - 240px) / ${(roomsDimensions?.x || 1) * 4})`
    const noShowHeight = `calc(calc(75dvh - 240px) / ${(roomsDimensions?.x || 1) * 4})`

    return (
        <Wrapper hasIncidences={hasIncidences}>
            <RoomCardHeader
                hasIncidences={hasIncidences}
                roomNumber={roomNumber}
                iconBgColor="var(--purple-drawer-primario)"
                iconName="DoorOpenNew"
                roomTypeAbbreviation={roomTypeName?.[0]}
            ></RoomCardHeader>
            <RoomCardBody>
                <div style={{ maxWidth }} className="room-card--xs--venta-en-linea__wrapper">
                    {isExceeded ? (
                        <>
                            <span className="room-card--xs--venta-en-linea__label" style={{ fontSize: itemHeight }}>
                                Venta en línea
                            </span>
                            <span className="room-card--xs--venta-en-linea__no-show" style={{ fontSize: noShowHeight }}>
                                No show
                            </span>
                        </>
                    ) : (
                        <>
                            <span className="room-card--xs--venta-en-linea__timer" style={{ fontSize: itemHeight }}>
                                {timeLeft}
                            </span>
                            <span className="room-card--xs--venta-en-linea__codigo" style={{ fontSize: itemHeight }}>
                                Código: {ventaEnLineaCodigo || "-"}
                            </span>
                        </>
                    )}
                </div>
            </RoomCardBody>
        </Wrapper>
    )
}

export default VentaEnLinea
